export const USE_AUTH0_US_FLAG = 'use-auth0-us';

export type Region = 'US' | 'EU';

/**
 * Mapping from internal region codes to AWS region identifiers.
 * Used for LaunchDarkly context and other region-specific features.
 */
export const REGION_TO_AWS: Record<Region, string> = {
  US: 'us-west-2',
  EU: 'eu-central-1',
};

export interface RegionEndpoints {
  customerApi: string;
  appcuesApi: string;
  imageServiceLambda: string;
  fastBaseUrl: string;
  jobApi: string;
}

export interface RegionConfig {
  domain: string;
  clientId: string;
  audience: string;
  baseUrl: string;
  studioUrl: string;
  endpoints: RegionEndpoints;
}

export const AUTH0_CONFIG: Record<Region, RegionConfig> = {
  US: {
    domain: import.meta.env.AUTH0_DOMAIN_US!,
    clientId: import.meta.env.AUTH0_CLIENT_ID_US!,
    audience: import.meta.env.CUSTOMER_API_URL!,
    baseUrl: import.meta.env.CUSTOMER_API_URL!,
    studioUrl: import.meta.env.STUDIO_URL!,
    endpoints: {
      customerApi: import.meta.env.CUSTOMER_API_URL!,
      appcuesApi: import.meta.env.APPCUES_API_URL!,
      imageServiceLambda: import.meta.env.IMAGE_SERVICE_LAMBDA_URL!,
      fastBaseUrl: import.meta.env.FASTLY_URL!,
      jobApi: import.meta.env.JOB_API_URL!,
    },
  },
  EU: {
    domain: import.meta.env.AUTH0_DOMAIN_EU!,
    clientId: import.meta.env.AUTH0_CLIENT_ID_EU!,
    audience: import.meta.env.CUSTOMER_API_URL_EU!,
    baseUrl: import.meta.env.CUSTOMER_API_URL_EU!,
    studioUrl: import.meta.env.STUDIO_URL_EU!,
    endpoints: {
      customerApi: import.meta.env.CUSTOMER_API_URL_EU!,
      appcuesApi: import.meta.env.APPCUES_API_URL_EU!,
      imageServiceLambda: import.meta.env.IMAGE_SERVICE_LAMBDA_URL_EU!,
      fastBaseUrl: import.meta.env.FASTLY_URL_EU!,
      jobApi: import.meta.env.JOB_API_URL!,
    },
  },
};
